<template>
    <div class="flex flex-col mx-auto w-full p-12 lg:p-24 text-left" style="max-width: 1400px;" v-if="news.length != 0">
        <h2 class="font-written text-4xl">Neuigkeiten</h2>
        <p class="text-lg text-gray-500 mt-3">News und Veranstaltungen</p>
        <div class="w-full flex flex-wrap gap-2 mt-5">
            <template v-for="i in news.slice(0, currentNews)" :key="i">
                <div class="w-[100%] flex-auto sm:flex-none sm:w-[32%] md:w-[49%] xl:w-[32%] min-h-52 h-auto flex flex-col md:flex-row bg-white 
                    rounded-xl overflow-hidden shadow-lg hover:scale-[102%] hover:z-20 duration-200 select-none cursor-pointer group"
                    @click="this.$router.push(`/artikel/${i.id}`)">
                    <img :src="CMS_URL + '/assets/' + i.Titelbild"
                        class="h-48 md:h-64 w-full md:w-1/2 object-cover rounded-md"
                        v-if="i.Titelbild" draggable="false">
                    <div class="h-48 md:h-64 md:h-full w-full md:w-1/2 object-cover rounded-md bg-gray-500 flex"
                        v-if="!i.Titelbild">
                        <svg class="size-16 text-white m-auto" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                            width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                            <path fill-rule="evenodd"
                                d="M5 5a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1 2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a2 2 0 0 1 2-2ZM3 19v-7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm6.01-6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-10 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="w-full md:w-1/2 flex-auto flex flex-col py-5 px-5">
                        <p class="font-bold line-clamp-2">{{ i.Titel }}</p>
                        <p class="text-sm mt-3 line-clamp-4 break-words">
                            {{ i.Kurzbeschreibung }}
                        </p>
                        <div class="flex justify-between flex-wrap mb-5" v-if="i.Tag_des_Ereignisses">
                            <div class="flex gap-2 items-center mt-3 mr-3">
                                <svg class="w-4 h-4 text-gray-500 mb-1" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                    viewBox="0 0 24 24">
                                    <path fill-rule="evenodd"
                                        d="M5 5a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1 2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a2 2 0 0 1 2-2ZM3 19v-7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm6.01-6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-10 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
                                        clip-rule="evenodd" />
                                </svg>
                                <p class="text-sm text-gray-500">{{ moment(i.Tag_des_Ereignisses).format(`DD. MMMM
                                    YYYY`) }}
                                </p>
                            </div>
                            <!-- <div class="flex gap-2 items-center mt-3">
                                <svg class="w-4 h-4 text-gray-500 mb-1" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                    viewBox="0 0 24 24">
                                    <path fill-rule="evenodd"
                                        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z"
                                        clip-rule="evenodd" />
                                </svg>
                                <p class="text-sm text-gray-500">{{ moment(i.Tag_des_Ereignisses).format(`HH:mm`) }}
                                </p>
                            </div> -->
                        </div>
                        <div class="flex gap-2 items-center group-hover:underline mt-auto ml-auto">
                            <p class="text-sm">Artikel lesen</p>
                            <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4" />
                            </svg>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <button class="mx-auto mt-5 hover:text-primary-default hover:underline" v-if="news.length > 3"
            @click="currentNews < news.length ? currentNews += 3 : currentNews = 3;">{{ currentNews >=
        news.length ?
        'Weniger anzeigen' : 'Mehr anzeigen' }}</button>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        return {
            news: [],
            currentNews: 3,
            CMS_URL: process.env.VUE_APP_CMS_URL,
            moment
        }
    },
    async created() {
        this.news = await this.$userStore.getNews();
    }
}
</script>